import { css } from '@emotion/react'

import type { IAgentItem } from '@/store/agents/interfaces'

import AgentRow from './AgentRow'

const agentListCss = css`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`

interface IAgentListProps {
  agents: IAgentItem[]
  recipients: string[]
  updateRecipients: (email: string) => void
}

const AgentList = ({
  agents,
  recipients,
  updateRecipients,
}: IAgentListProps) => {
  return (
    <div css={agentListCss}>
      {agents.map((agent) => (
        <AgentRow
          key={agent.account_id}
          agent={agent}
          checked={recipients.includes(agent.email)}
          updateRecipients={updateRecipients}
        />
      ))}
    </div>
  )
}

export default AgentList
